import React from "react";
import { Route, Routes } from "react-router-dom";
import { HomePage } from "./pages/home";
import { LoginPage } from "./pages/login";
import { RouterLayout } from "./common/RouterLayout";
import { RegisterPage } from "./pages/register";
import { DashboardPage } from "./pages/home/dashboard";
import { ActoresPage } from "./pages/creacionExpertos/Actores";
import { ActorDetailPage } from './pages/creacionExpertos/ActorDetailPage';
import { AgentesPage } from './pages/creacionExpertos/Agentes';
import { ChatPage } from "./pages/home/chat";
import { MainBar } from "./common/MainBar";

export const AppRouter: React.FC<{}> = () => {
    return (
        <Routes>
            <Route path="/" element={<RouterLayout />}>
                <Route path="/" element={<LoginPage />}>
                </Route>
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/chat" element={<ChatPage />} />
                <Route path="/dash" element={<DashboardPage />} />
                <Route path="/chat" element={<ChatPage />} />
                <Route path="/agentes" element={<AgentesPage />} />
            </Route>
            <Route path="/actors/:id" element={<ActorDetailPage />} />
            <Route path="/" element={<HomePage />} />
            
            <Route path="/actores" element={<ActoresPage />} />
        </Routes>

    );
};